import {ClientReportSubmitInput} from "../../domain";
import {EnumToMapping} from "../../../../common";

export enum ServiceRecommended {
    Yes = 'Yes (Treatment Recommended)',
    No = 'No (Treatment Not Recommended)'
}

export const {
    nameToValue: ServiceRecommendedOptions,
} = EnumToMapping(ServiceRecommended);

// see ClientReportServiceRelateInput for the list for fields to be reset
export const relatedFieldsToBeSetNullOnNoServiceRecommended: Array<keyof ClientReportSubmitInput> = [
    'firstTreatmentOfferedDate',

    'caregiverMidLevelHoursMin',
    'caregiverMidLevelHoursMax',
    'caregiverHighLevelHoursMin',
    'caregiverHighLevelHoursMax',
    'practitionerParaprofessionalHoursMin',
    'practitionerParaprofessionalHoursMax',
    'practitionerMidLevelHoursMin',
    'practitionerMidLevelHoursMax',
    'practitionerHighLevelHoursMin',
    'practitionerHighLevelHoursMax',
    'practitionerGroupCareHoursMin',
    'practitionerGroupCareHoursMax',

    'treatmentOffered',

    'offeredParaprofessionalHours',
    'offeredMidLevelHours',
    'offeredHighLevelHours',
    'offeredGroupCareHours',

];
